import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Card,
  IconButton,
  Paper,
  Tooltip,
  Container,
  Divider,
  Grid,
  Button,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router";
import profile_img from "../../assets/img/profile_img.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import categoryCard1 from "../../assets/img/emp_img.png";
import categoryCard2 from "../../assets/img/emp_img.png";
import categoryCard3 from "../../assets/img/emp_img.png";
import categoryCard4 from "../../assets/img/emp_img.png";
import { useSelector } from "react-redux";
import SEO from "../../common/SEO";
import {
  getAllProfileEmployeeList,
  getBusinessProfile,
  getEmployeeList,
} from "./landingPageApi";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import axios from "axios";
const ProfilePage = () => {
  const navigate = useNavigate();
  const offersRef = useRef(null);
  const categoryPrevRef = useRef(null);
  const categoryNextRef = useRef(null);
  const categorySwiperRef = useRef(null);
  const [isBeginningCat, setIsBeginningCat] = useState(true);
  const [isEndCat, setIsEndCat] = useState(false);
  const details = useSelector((state) => state.reducer.detail);
  const [employees, setEmployees] = useState([]);
  const [business, setBusiness] = useState();
  useEffect(() => {
    console.log(details, "profile page");
  }, [details]);

  const profileUrl = "https://elegantprime.in/profile?clientId=25&area=wakad";

  const handleCopy = () => {
    navigator.clipboard.writeText(profileUrl);
    alert("Copied to clipboard");
  };

  // const fetchEmployees = async (billerId) => {
  //   try {
  //     console.log("Sending fetch request with billerId:", details?.billerId);

  //     // const response = await fetch(
  //     //   "https://elegantprime.in/webapp/user/api/v1/Salon/GetActiveEmployeeListV2",
  //     //   {
  //     //     method: "GET",
  //     //     // headers: {
  //     //     //   "Content-Type": "application/json",
  //     //     // },
  //     //     body: JSON.stringify({
  //     //       billerId: details?.billerId,
  //     //     }),
  //     //   }
  //     // );

  //    let res = await fetch("https://jsonplaceholder.typicode.com/todos/1")
  //       .then((response) => response.json())
  //       .then((json) => console.log(json));

  //     console.log("Fetch response:####", res);

  //     // if (!response.ok) {
  //     //   throw new Error(`HTTP error! Status: ${response.status}`);
  //     // }

  //     // const data = await response.json();
  //     // console.log("Response:", data);
  //     setEmployees(data);
  //   } catch (error) {
  //     console.error("Error fetching employee list:", error);
  //   }
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const payload = {
  //       billerId: details?.billerId,
  //     };
  //     // Convert payload to query string
  //     const query = new URLSearchParams(payload).toString();
  //     const url = `https://elegantprime.in/webapp/user/api/v1/Salon/GetActiveEmployeeListV2?${query}`;

  //     try {
  //      const response = await fetch(
  //        "https://elegantprime.in/webapp/user/api/v1/Salon/GetActiveEmployeeListV2",
  //        {
  //          method: "GET",
  //          headers: { "Content-Type": "application/json" },
  //          body: JSON.stringify({ billerId: details.billerId }),
  //        }
  //      );

  //       const data = await response.json();
  //       console.log("Response:!!!!!", data);
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   console.log("Details object:", details); // debug log

  //   if (details?.billerId) {
  //     console.log("Calling fetchEmployees...");
  //     fetchEmployees();
  //   } else {
  //     console.log("No billerId found. Skipping API call.");
  //   }
  // }, [details]);

  // useEffect(() => {
  //   if (details?.billerId) {
  //     getEmployeeList(details.billerId, (res) => {
  //       setEmployees(res.data);
  //     });
  //   }
  // }, [details]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (employee) => {
    setSelectedEmployee(employee);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmployee(null);
  };

  useEffect(() => {
    if (details?.billerId !== undefined) {
      getEmployeeList({ billerId: details.billerId })
        .then((res) => {
          setEmployees(res.data?.data?.list);
        })
        .catch((err) => {
          console.error("Error fetching employees:", err);
        });
    }
  }, [details]);
  useEffect(() => {
    if (details?.id !== undefined) {
      getBusinessProfile({ id: details.id })
        .then((res) => {
          setBusiness(res?.data?.data);
        })
        .catch((err) => {
          console.error("Error fetching employees:", err);
        });
    }
  }, [details]);
  console.log("Employees state:", business);

 



  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/profile"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box p={{sm:2, xs:0}}>
        {/* Back Button */}
        <IconButton
          size="small"
          sx={{ mb: 2, mt: { sm: 4, xs: 1 }, mx: { sm: 6, md: 10, xs: 2 } }}
          onClick={() => navigate("/salon")}
        >
          <KeyboardBackspaceIcon sx={{ color: "#01008B", fontSize: "30px" }} />
        </IconButton>

        <Container maxWidth={"lg"}>
          {/* Profile Section */}
          <Container maxWidth="md">
            <Card
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                backgroundColor: "#e2deff",
                borderRadius: 2,
                p: 2,
                alignItems: "center",
                gap: { xs: 2, sm: 4 },
              }}
            >
              {/* Left Logo */}
              <Box
                component="img"
                src={profile_img}
                alt="Salon Logo"
                sx={{
                  width: { xs: 100, sm: 150, md: 200 },
                  height: { xs: 100, sm: 150, md: 200 },
                  objectFit: "contain",
                  alignSelf: { xs: "center", sm: "flex-start" },
                }}
              />

              {/* Right Content */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                sx={{ width: "100%" }}
              >
                <Typography
                  variant="h6"
                  fontWeight={600}
                  fontSize={{ xs: 20, sm: 25, md: 30 }}
                >
                  {details.enterpriseName}
                </Typography>

                <Typography
                  fontWeight={600}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, mt: 0.5 }}
                >
                  {details.area}
                </Typography>
                <Typography
                  fontWeight={600}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, mt: 0.5 }}
                >
                  {details.mobileNumber}
                </Typography>
                <Typography
                  fontWeight={600}
                  sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, mt: 0.5 }}
                >
                  {details.mailID1}
                </Typography>

                {/* Profile ID Card */}
                <Paper
                  elevation={3}
                  sx={{
                    mt: 2,
                    p: 2,
                    flexWrap: "wrap",
                    maxWidth: "100%",
                    overflowWrap: "break-word",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography fontWeight={600} pb={1}>
                      Profile ID
                    </Typography>
                    <Box>
                      <Tooltip title="Copy">
                        <IconButton size="small" onClick={handleCopy}>
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Share">
                        <IconButton size="small">
                          <ShareIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      wordBreak: "break-word",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      mt: 1,
                    }}
                  >
                    {details.profileId}
                  </Typography>
                </Paper>
              </Box>
            </Card>
          </Container>

          {/* Employees section */}
          <Box mt={5}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: { xs: "18px", sm: "22px", md: "25px" },

                    fontWeight: 700,
                    paddingLeft: "20px",
                  }}
                >
                  Employees
                </Typography>
                <Box sx={{ width: "100%", position: "relative" }}>
                  {/* ref={offersRef} */}
                  <Button
                    ref={categoryPrevRef}
                    sx={{
                      position: "absolute",
                      height: { xs: "40px", sm: "40px", md: "100%" },
                      top: { xs: "50%", sm: "50%", md: "0" },
                      transform: {
                        xs: "translateY(-50%)",
                        sm: "translateY(-50%)",
                        md: "none",
                      },

                      bottom: "0",
                      left: "0",
                      zIndex: 99,
                      borderTopRightRadius: 0,
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      borderTopLeftRadius: "10px",
                      borderBottomLeftRadius: "10px",
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility: "visible", // for Prev
                    }}
                  >
                    <ArrowBackIosNewIcon />
                  </Button>
                  <Button
                    ref={categoryNextRef}
                    sx={{
                      position: "absolute",
                      height: { xs: "40px", sm: "40px", md: "100%" },
                      top: { xs: "50%", sm: "50%", md: "0" },

                      transform: {
                        xs: "translateY(-50%)",
                        sm: "translateY(-50%)",
                        md: "none",
                      },

                      bottom: "0",
                      right: "0",
                      zIndex: 99,
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: "10px",
                      borderBottomRightRadius: "10px",
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility: "visible", // for Next
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </Button>
                  <Swiper
                    style={{ height: "100%" }}
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={3}
                    loop={true}
                    autoplay={{ delay: 3000 }}
                    onSwiper={(swiper) => {
                      categorySwiperRef.current = swiper;
                      if (
                        categoryPrevRef.current &&
                        categoryNextRef.current &&
                        !swiper.params.navigation?.initialized
                      ) {
                        swiper.params.navigation.prevEl =
                          categoryPrevRef.current;
                        swiper.params.navigation.nextEl =
                          categoryNextRef.current;
                        swiper.navigation.init();
                        swiper.navigation.update();
                      }
                    }}
                    breakpoints={{
                      1440: { slidesPerView: 3 },
                      1024: { slidesPerView: 2.5 },
                      768: { slidesPerView: 1.8 },
                      425: { slidesPerView: 1.2 },
                      375: { slidesPerView: 1 },
                      320: { slidesPerView: 1 },
                    }}
                  >
                    {employees.map((item, idx) => (
                      <SwiperSlide key={idx} style={{ height: "100%" }}>
                        <Card
                          onClick={() => handleOpen(item)}
                          sx={{
                            padding: "4px",
                            boxShadow: "0px 4px 4px 0px #00000040",
                            bgcolor: "#EEEEFB",
                            cursor: "pointer",
                            height: {
                              lg: "200px",
                              md: "180px",
                              sm: "180px",
                              xs: "200px",
                            },
                          }}
                        >
                          <CardContent
                            sx={{
                              height: "100%",

                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              "&:last-child": {
                                paddingBottom: 0,
                              },
                            }}
                          >
                            <Box>
                              <img
                                src={categoryCard1}
                                alt="Offer"
                                style={{ width: "100px", height: "100px" }}
                              />
                            </Box>

                            <Box display="flex" flexDirection="column">
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#000",
                                  fontWeight: 600,
                                  fontSize: 18,
                                }}
                              >
                                {item.name}
                              </Typography>
                              {/* <Typography
                                sx={{
                                  color: "#000",
                                  fontWeight: 500,
                                  fontSize: 14,
                                }}
                              >
                               A salon is a business that
                                provides beauty and personal.
                              </Typography> */}
                              <Typography
                                sx={{
                                  color: "#555",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    // md: "15px",
                                  },
                                  mt: 0.5,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: {
                                    lg: "200px",
                                    md: "180px",
                                    sm: "180px",
                                    xs: "100px",
                                  },
                                }}
                              >
                                {item?.specialization || ""}
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#555",

                                  fontWeight: 500,
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    // md: "15px",
                                  },
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: {
                                    lg: "200px",
                                    md: "180px",
                                    sm: "180px",
                                    xs: "100px",
                                  },
                                }}
                              >
                                {item?.skillSet || "No skill set provided"}
                              </Typography>
                              {item?.achievements && (
                                <Typography
                                  sx={{
                                    color: "#333",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "13px",
                                      // md: "15px",
                                    },

                                    mt: 0.5,
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    maxWidth: {
                                      lg: "200px",
                                      md: "180px",
                                      sm: "180px",
                                      xs: "100px",
                                    },
                                  }}
                                >
                                  {item.achievements}
                                </Typography>
                              )}
                              <Typography
                                sx={{
                                  color: "#777",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    // md: "15px",
                                  },

                                  mt: 0.5,
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  maxWidth: {
                                    lg: "200px",
                                    md: "180px",
                                    sm: "180px",
                                    xs: "100px",
                                  },
                                }}
                              >
                                {item?.overview}
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>
              </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
              <DialogTitle>
                {/* {selectedEmployee?.name} */}
                <Typography
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  }}
                  variant="subtitle1"
                  color={"#b5006b"}
                  fontWeight={600}
                >
                  Employee Profile
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: " #000000",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent
                dividers
                sx={{
                  minWidth: { sm: "300px", xs: "200px" }, // ✅ Set minWidth here
                }}
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  {/* <Box display="flex" justifyContent="center">
                    <img
                      src={categoryCard1}
                      alt="Employee"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                      }}
                    />
                  </Box> */}

                  <Typography
                    color={"#01008B"}
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    Specialization
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    {selectedEmployee?.specialization || "N/A"}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                    variant="subtitle1"
                    color={"#01008B"}
                    fontWeight={600}
                  >
                    Skill Set
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    {selectedEmployee?.skillSet || "No skill set provided"}
                  </Typography>

                  {selectedEmployee?.achievements && (
                    <>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                        color={"#01008B"}
                        variant="subtitle1"
                        fontWeight={600}
                      >
                        Achievements
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {selectedEmployee.achievements}
                      </Typography>
                    </>
                  )}

                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                    color={"#01008B"}
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    Overview
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    {selectedEmployee?.overview || "N/A"}
                  </Typography>
                </Box>
              </DialogContent>
            </Dialog>
          </Box>

          {/* - Border Section Starts Here - */}
          {/* {overviewSections.map((section, index) => (
            <Box key={index} my={4}>
              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <Divider sx={{ width: "30px", borderColor: "#999" }} />
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
                >
                  {section.title}
                </Typography>
                <Divider sx={{ flex: "1", borderColor: "#999" }} />
              </Box>

              {section.title === "Terms & Conditions" ? (
                <ol style={{ paddingLeft: "20px" }}>
                  {terms.description.map((sec, idx) => (
                    <li key={idx}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 400, color: "#000000" }}
                      >
                        {sec.title}
                      </Typography>
                      <ul style={{ paddingLeft: "20px" }}>
                        {sec.points.map((point, i) => (
                          <li key={i}>
                            <Typography
                              variant="body2"
                              sx={{ color: "#333", lineHeight: 1 }}
                            >
                              {point}
                            </Typography>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ol>
              ) : (
                section.description.split("\n").map((line, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{ color: "#333", lineHeight: 1.7 }}
                  >
                    {line}
                  </Typography>
                ))
              )}
            </Box>
          ))} */}
          {business && (
            <>
              {/* Overview */}
              <Box my={4}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Divider sx={{ width: "30px", borderColor: "#999" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
                  >
                    Overview
                  </Typography>
                  <Divider sx={{ flex: "1", borderColor: "#999" }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", lineHeight: 1.5 }}
                >
                  {business.overview || "N/A"}
                </Typography>
              </Box>

              {/* Terms and Conditions */}
              <Box my={4}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Divider sx={{ width: "30px", borderColor: "#999" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
                  >
                    Terms & Conditions
                  </Typography>
                  <Divider sx={{ flex: "1", borderColor: "#999" }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", lineHeight: 1.5 }}
                >
                  {business.termsAndConditions || "N/A"}
                </Typography>
              </Box>

              {/* Specialization */}
              <Box my={4}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Divider sx={{ width: "30px", borderColor: "#999" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
                  >
                    Specialization
                  </Typography>
                  <Divider sx={{ flex: "1", borderColor: "#999" }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", lineHeight: 1.5 }}
                >
                  {business.specialization || "N/A"}
                </Typography>
              </Box>

              {/* Achievements */}
              <Box my={4}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Divider sx={{ width: "30px", borderColor: "#999" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
                  >
                    Achievements
                  </Typography>
                  <Divider sx={{ flex: "1", borderColor: "#999" }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", lineHeight: 1.5 }}
                >
                  {business.achievements || "N/A"}
                </Typography>
              </Box>
            </>
          )}
        </Container>
      </Box>
    </>
  );
};

export default ProfilePage;
